import VueRouter, { RouteConfig } from 'vue-router'

const Index = () => import('../activity/fission-s3/Index.vue')
const Rules = () => import('../activity/fission-s3/Rules.vue')
const Poster = () => import('../activity/fission-s3/Poster.vue')

export const fissionS3ActivityRoute: RouteConfig = {
  path: '/fission-s3-activity',
  name: 'fission_s3_activity',
  component: Index,
  meta: {
    title: '邀请有奖',
  },
}

export const fissionS3ActivityRulesRoute: RouteConfig = {
  path: '/fission-s3-activity-rules',
  name: 'fission_s3_activity_rules',
  component: Rules,
  meta: {
    title: '活动规则',
  },
}

export const fissionS3ActivityPosterRoute: RouteConfig = {
  path: '/fission-s3-activity-poster',
  name: 'fission_s3_activity_poster',
  component: Poster,
  meta: {
    title: '分享海报',
  },
}

export default [fissionS3ActivityRoute, fissionS3ActivityRulesRoute, fissionS3ActivityPosterRoute]

export function navigateToFissionS3ActivityRules(router: VueRouter) {
  router.push({ name: fissionS3ActivityRulesRoute.name })
}
export function navigateToFissionS3ActivityPoster(router: VueRouter) {
  router.push({ name: fissionS3ActivityPosterRoute.name })
}
